/**
 * Notify Middleware
 */
import { buildNotificationMessage } from "reducers/Notifications";

function NotifyMiddleware(store){
	return function(next){
		return function(action){
			if(action.meta && action.meta.notify) {
				if(action.meta.notify.length){
					action.meta.notify.forEach((v) => {
						next(buildNotificationMessage(v));
					});
				} else {
					next(buildNotificationMessage(action.meta.notify));
				}
			}
			return next(action);
		};
	};
}

export default NotifyMiddleware;
